module.exports = __webpack_public_path__ + "static/media/TN-Women-Dress-2.0_OptionAll.dd681a36.svg";